<template>
  <CSATChart :csatReport="reportData" />
</template>

<script>
import CSATChart from "@/pages/reports/components/CSATCharts.vue";

export default {
  components: {
    CSATChart,
  },
  props: {
    selectedFilters: {
      type: Object,
      default: () => ({})
    },
    reportData: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
};
</script>
